import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Router, ActivatedRoute } from '@angular/router';

import { ApiService, MessagesService } from '@angular/synthrone-design/services';
import { APP_CONFIG } from '@synthroneApp/app.config';

import { MatDialog } from '@angular/material';
import { LanguageServiceSDK } from 'ms-language-country-angular-sdk';

@Component({
  selector: 'app-languages-view',
  templateUrl: './languages-view.component.html',
  styleUrls: ['./languages-view.component.scss']
})
export class LanguagesViewComponent {

  @ViewChild('languageTable') languageTable;

  configColumns = {
      name: {
          label: 'Name',
          sortable: false,
          truncate: true
      },
      isoCode: {
          label: 'ISO Code',
          sortable: false,
          truncate: true
      }
  };
  languages = [];

  constructor(
    private languageService: LanguageServiceSDK,
    private _router: Router,
    private route: ActivatedRoute,
    private messagesService: MessagesService,
    protected api: ApiService,
    @Inject(APP_CONFIG) private config,
    protected dialog: MatDialog
  ) { }

  ngOnInit() {
    this.getLanguages().then(() => {
      this.route.queryParams.subscribe(() => { this.refreshTable() });
    })
  }

  refreshTable = () => {
      this.languageTable.getData()
  };

  breadcrumbsFN = () => {
    return Observable.of([
      {
        breadcrumb: 'ADMINER',
        url: '/'
      },
      {
        breadcrumb: 'Manage Languages',
        url: '/languages'
      }
    ]);
  };

  sdLangs = (limit: any, offset: any): Observable<any> => {
    return Observable.of(this.languages);
  };

  getLanguages(): Promise<void> {
    return new Promise<void>((resolve) => {
      this.api.makeSDKRequest(this.languageService, 'languageGet', false)
        .subscribe((results: any[]) => {
          this.languages = results;
          resolve();
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/components/views/languages-view/languages-view.component.ts